import { Alert, Box, Button, Flex, Typography } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { FormTitle } from '../../../common/components/FormTitle/FormTitle';

export const ErrorState: FC = () => {
  return (
    <Box padding={4} borderRadius="l">
      <Flex col>
        <Flex.Item marginBottom={6}>
          <FormTitle>Contribution</FormTitle>
        </Flex.Item>
        <Alert
          showIcon
          type="warning"
          message={
            <Typography.Body>
              You did not pass KYC during the “whitelist” phase. Unfortunately,
              you are not eligible for participation. If you{' '}
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              believe there is a mistake, don't hesitate to reach out to us in
              the{' '}
              <Button
                href="https://discord.gg/kGp44bdpq7"
                target="_blank"
                type="link"
                style={{
                  padding: 0,
                  height: 0,
                  lineHeight: 0,
                  display: 'inline-block',
                }}
              >
                Discord community
              </Button>{' '}
              for assistance.
            </Typography.Body>
          }
        />
      </Flex>
    </Box>
  );
};
